<template>
  <div>
    <div v-if="loading" class="loading-block">
      <div class="loader"></div>
    </div>
    <div v-if="data">
      <div class="row" style="margin-bottom: 3px;">
        <div class="col">
          <b>Звонки</b>
        </div>
        <div class="col">Показано: {{data.length}} из {{pager.count}}</div>
        <div class="col text-right">
          <div style="margin:-13px 0px 0px 0px; white-space: nowrap;">
            <button
              class="btn btn-secondary btn-round"
              style="margin: 2px;"
              @click="setPage(0)"
            >
              <i class="fas fa-chevron-left"></i>
            </button>
            <button
              v-for="(item, key) in pages.page"
              :key="key"
              @click="setPage(item)"
              class="btn btn-round"
              :class="item == pages.current ? 'btn-primary' : 'btn-secondary'"
              style="margin: 2px;"
            >{{item + 1}}</button>
            <button
              class="btn btn-secondary btn-round"
              style="margin: 2px;"
              @click="setPage(maxPage())"
            >
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="tbl fixed" style="top:60px; min-width: 500px;">
        <div class="row tbl-row tbl-header">
          <div class="tbl-col col-2 sortable" @click="sortBy('calldate')">
            Дата
            <span v-if="sort.key != 'calldate'">
              <i class="fas fa-sort"></i>
            </span>
            <span v-else class="arrow">
              <i class="fas" :class="sort.order == 'DESC' ? 'fa-sort-up' : 'fa-sort-down'"></i>
            </span>
          </div>
          <div class="tbl-col col-2 sortable" @click="sortBy('clid')">
            Клиент
            <span v-if="sort.key != 'clid'">
              <i class="fas fa-sort"></i>
            </span>
            <span v-else class="arrow">
              <i class="fas" :class="sort.order == 'DESC' ? 'fa-sort-up' : 'fa-sort-down'"></i>
            </span>
          </div>
          <div class="tbl-col col-2 sortable" @click="sortBy('src')">
            Откуда
            <span v-if="sort.key != 'src'">
              <i class="fas fa-sort"></i>
            </span>
            <span v-else class="arrow">
              <i class="fas" :class="sort.order == 'DESC' ? 'fa-sort-up' : 'fa-sort-down'"></i>
            </span>
          </div>
          <div class="tbl-col col-2 sortable" @click="sortBy('dst')">
            Куда
            <span v-if="sort.key != 'dst'">
              <i class="fas fa-sort"></i>
            </span>
            <span v-else class="arrow">
              <i class="fas" :class="sort.order == 'DESC' ? 'fa-sort-up' : 'fa-sort-down'"></i>
            </span>
          </div>
          <div class="tbl-col col-1 sortable" @click="sortBy('billsec')">
            Время
            <span v-if="sort.key != 'billsec'">
              <i class="fas fa-sort"></i>
            </span>
            <span v-else class="arrow">
              <i class="fas" :class="sort.order == 'DESC' ? 'fa-sort-up' : 'fa-sort-down'"></i>
            </span>
          </div>
          <div class="tbl-col col-2">Запись</div>
        </div>
        <div class="row tbl-row tbl-header">
          <div class="tbl-col col-2">
            <input type="text" @change="onChangeFilter('calldate')" v-model="filters.calldate">
          </div>
          <div class="tbl-col col-2">
            <input type="text" @change="onChangeFilter('clid')" v-model="filters.clid">
          </div>
          <div class="tbl-col col-2">
            <input type="text" @change="onChangeFilter('src')" v-model="filters.src">
          </div>
          <div class="tbl-col col-2">
            <input type="text" @change="onChangeFilter('dst')" v-model="filters.dst">
          </div>
          <div class="tbl-col col-1"></div>
          <div class="tbl-col col-2"></div>
        </div>
        <div class="tbl-body" style="top: 64px;">
          <div v-for="(item, key) in data" :key="key" class="row tbl-row">
            <div class="tbl-col col-2">{{item.calldate}}</div>
            <div class="tbl-col col-2">{{item.clid}}</div>
            <div class="tbl-col col-2">{{item.src}}</div>
            <div class="tbl-col col-2">{{item.dst}}</div>
            <div class="tbl-col col-1">{{item.billsec}}</div>
            <div class="tbl-col col-2" v-html="player(item.recordingfile)"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
import axios from "axios";
import router from "@/config/router";
import api from "@/config/api";
import func from "@/libs/func";

export default {
  data: function() {
    return {
      loading: false,
      data: [],
      sort: {
        key: "calldate",
        order: "DESC"
      },
      pager: {
        page: 0,
        count: 0,
        limit: 20
      },
      pages: {
        current: 0,
        page: []
      },
      filters: {}
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: "updateRoute"
  },
  methods: {
    maxPage: function() {
      return Math.ceil(this.pager.count / this.pager.limit)
    },
    setPage: function(item) {
      if (item < 0) {
        item = 0;
      }
      if (item >= this.maxPage()) {
        item = this.maxPage() - 1
      }
      this.pager.page = item;
      this.push();
    },
    updatePages: function() {
      let num = 6
      this.pages = {
        current: this.pager.page,
        page: []
      };
      var start = 0, stop = this.maxPage()
              // this.pages.page.push(0)
      if (this.maxPage() > num) {
        if (this.pager.page < Math.floor(num / 2)) {
          stop = num
        } else if (this.maxPage() - this.pager.page < Math.floor(num / 2)) {
          start = this.maxPage() - num
        } else {
          start = this.pager.page - Math.floor(num / 2)
          stop = this.pager.page + Math.floor(num / 2)
        }
        


      }
      for (var i = start; i < stop; i++) {
        this.pages.page.push(i)
      }
    },
    player: function(url) {
      return (
        '<audio controls><source src="http://sip.andreyonweb.ru' +
        url +
        '" type="audio/mpeg"></audio>'
      );
    },
    onChangeFilter: function() {
      this.pager.page = 0;
      this.push();
    },
    sortBy: function(el) {
      if (this.sort.key == el) {
        if (this.sort.order == "ASC") {
          this.sort.order = "DESC";
        } else {
          this.sort.order = "ASC";
        }
      } else {
        this.sort.key = el;
        this.sort.order = "ASC";
      }
      this.push();
    },
    push: function() {
      var params = {
        sort: this.sort,
        filters: this.filters,
        pager: this.pager
      };
      router.push({ query: { q: func.url_encode(params) } });
    },
    updateRoute: function() {
      this.fetchData();
    },
    fetchData: function() {
      let params = {};
      if (this.$route.query.q) {
        params = func.url_decode(this.$route.query.q);
        if (params.sort) {
          this.sort = params.sort;
        }
        if (params.filters) {
          this.filters = params.filters;
        }
      }
      this.loading = true;
      axios
        .get(api.crd, { params: params })
        .then(response => {
          this.loading = false;
          if (response.data.status == "ok") {
            this.data = response.data.data;
            this.pager = response.data.pager;
            this.updatePages();
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>